module.exports = __webpack_public_path__ + "static/images/wallet.2tnyE3t.svg";